<div class="comparison-table">    
    <ion-grid>
      <ion-row class="header-row">
        <ion-col size="4"  *ngFor="let column of headerData.columns" [ngClass]="column.columnClass">
          <strong>{{ column.value }}</strong>
        </ion-col>
      </ion-row>
    
      <app-expandable-table-row
        *ngFor="let row of tableData.rows"
        [columns]="columns"
        [rowData]="row"
        [subRows]="row.subRows">
      </app-expandable-table-row>
    </ion-grid>
    
</div>
